import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LayoutService {
	private scrollTo = new Subject();
	scrollToChanges$ = this.scrollTo.asObservable();

	changeScrollToValue(value: number) {
		this.scrollTo.next(value);
	}
}
